import React, { useEffect, useState, useMemo } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import LoadingOverlay from 'components/LoadingOverlay';
import { H1 } from 'components/Typography';
import { getEntriesByContentTypeAndProduct } from 'api/contentful';
import { SearchProvider } from './hooks/useSearch';
import {
  PolicyPage,
  NavBg,
  TitleHeader,
  StyledSearchInputHeader,
  StyledSideNav,
  StyledDropdownNav,
  StyledQuestions,
  LoadingContainer,
  StyledHeaderBg,
  DownloadLink
} from './styled';

const Policy = () => {
  const [questions, setQuestions] = useState([]);
  const [pdfUrl, setPdfUrl] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const urlVersion = useMemo(() => queryString.parse(location.search).version, []);

  const fetchData = async () => {
    const data = await getEntriesByContentTypeAndProduct('policy', 'nomad-insurance', 5);
    let selectedVersion = data[0];
    if (urlVersion) {
      const versionInUrl = data.find(
        (policy) => policy.fields.effectiveDate === urlVersion
      );
      selectedVersion = versionInUrl || data[0];
    }
    setQuestions(selectedVersion.fields.questions);
    setPdfUrl(selectedVersion.fields.policyDocumentPdf?.fields.file?.url);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [urlVersion]);

  return (
    <PolicyPage isLoading={isLoading}>
      <SearchProvider>
        <NavBg />
        <StyledHeaderBg />
        <TitleHeader>
          <H1>Nomad Insurance Essential description of coverage</H1>
          <DownloadLink href={pdfUrl} target="_blank" rel="noopener noreferrer">
            View description of coverage PDF
          </DownloadLink>
        </TitleHeader>
        <StyledSearchInputHeader />
        {isLoading ? (
          <LoadingContainer>
            <LoadingOverlay isLoading variant="light" />
          </LoadingContainer>
        ) : (
          <>
            <StyledSideNav questions={questions} />
            <StyledDropdownNav questions={questions} />
            <StyledQuestions questions={questions} />
          </>
        )}
      </SearchProvider>
    </PolicyPage>
  );
};

export default Policy;
